/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseSocial from 'scripts/social/base';

export default BaseSocial.extend({

    init: function () {
        this._super();
        this.apiUrl = this.appConfig.urls.api.instagram.apiUrl;
    },

    isApiAvailable: function () {
        return !!window.instgrm;
    },
    create: function (element, params) {
        this.initialize();
        this.socialAwaiting.then(function () {
             var $element = this.$(element);
             $element.append(params.embed.html);

             if (window.instgrm.Embeds) {
                 window.instgrm.Embeds.process();
             }
            }.bind(this)
        );
    },
}, {});
